module.exports = __webpack_public_path__ + "static/media/black-jeans.495d6441.jpg";